import React from 'react';
import {
  SwipeableProvider,
  SwipeableContext,
} from 'ha/modules/SwipeableSlider';
import { Gallery } from '../components/Gallery';
import { ContentManager } from './ContentManager';
import { Content } from '../types';

export interface Props {
  onClose: () => void;
  content: Content[];
  initialSlideIndex?: number;
  initialContentName?: string;
}

const GalleryContainer: React.FC<Props> = ({
  onClose,
  initialSlideIndex = 0,
  initialContentName,
  content,
}) => {
  const defaultContentSettings = {
    withThumbnails: true,
    withSlideIndex: true,
  };

  const contentData = content.map(contentItem => ({
    ...defaultContentSettings,
    ...contentItem,
  }));

  return (
    <ContentManager
      content={contentData}
      initialContentName={initialContentName}
    >
      {contentProps => (
        <SwipeableProvider
          content={contentProps.element}
          initialSlideIndex={initialSlideIndex}
        >
          <SwipeableContext.Consumer>
            {swipeableProps => (
              <Gallery
                {...swipeableProps}
                withControls={contentProps.element.withControls}
                withThumbnails={contentProps.element.withThumbnails}
                withSlideIndex={contentProps.element.withSlideIndex}
                thumbnails={contentProps.element.thumbnails}
                contentIndex={contentProps.index}
                navigationContent={content.map(element => element.navigation)}
                handleChangeContentIndex={contentProps.onChangeContent}
                onClose={onClose}
              />
            )}
          </SwipeableContext.Consumer>
        </SwipeableProvider>
      )}
    </ContentManager>
  );
};

export { GalleryContainer };
